import { render, staticRenderFns } from "./SubjectSupplyPointsComponent.vue?vue&type=template&id=378af684"
import script from "./SubjectSupplyPointsComponent.vue?vue&type=script&lang=js"
export * from "./SubjectSupplyPointsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports